import React, { useState, useEffect } from "react";
import { format } from "date-fns";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Box from "@material-ui/core/Box";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(3),
  },
}));

// Histórico de disparos de uma regra de resposta automática: quando
// respondeu, pra quem, e em qual atendimento.
const AutoReplyRuleLogsModal = ({ open, onClose, rule }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);

  const fetchLogs = async () => {
    if (!rule) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/auto-reply-rules/${rule.id}/logs`);
      setLogs(data);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) fetchLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, rule]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Histórico — {rule?.name}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box className={classes.loadingBox}>
            <CircularProgress />
          </Box>
        ) : logs.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            Essa regra ainda não disparou nenhuma vez.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Quando</TableCell>
                <TableCell>Contato</TableCell>
                <TableCell>Ticket</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map(log => (
                <TableRow key={log.id}>
                  <TableCell>
                    {format(new Date(log.repliedAt), "dd/MM/yyyy HH:mm")}
                  </TableCell>
                  <TableCell>
                    {log.ticket?.contact?.name || log.ticket?.contact?.number || "-"}
                  </TableCell>
                  <TableCell>#{log.ticket?.id ?? "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoReplyRuleLogsModal;
